<template>
  <div
    id="friends"
    class="menucontent modal-overlay"
    v-if="showModal"
    style="overflow-y: auto; max-height: 100%"
  >
    <div class="inmenucontent animate__animated animate__bounceIn" :style="{ backgroundImage: createBackgroundString }">
      <button class="hidemenu" @click="hide">
        <i class="fas fa-times"></i>
      </button>
      <div class="ininmnct">
        <div class="menuhead mb-3"><i class="fas fa-users"></i> ชวนเพื่อน</div>
        <div class="friendsimg">
          <!-- <iframe class="iframe-aff" src="https://www.youtube.com/embed/9zEl-FQLI4A" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture">
            </iframe> -->
        </div>
        <div class="headerbankdt mt-2 mb-0">
          <!-- <img src="images/icon/cd.png" />  -->
          รายได้แนะนำเพื่อน
        </div>
        <hr class="x-hr-border-glow mb-1 mt-1" />
        <div class="col order-lg-2 order-0 -form">
          <div class="moneycontainaf1">
            <div class="friendcontent">
              <br />
              <table style="width: 100%">
                <tbody>
                  <tr>
                    <td
                      colspan="2"
                      style="position: relative; text-align: center;" class="qrcodebg"
                    >
                      <div style="margin-top: 8px;">
                        <qrcode-vue
                          :value="ref"
                          :size="size"
                          level="H"
                        ></qrcode-vue>
                      </div>
                    </td>
                    <!-- <td style="text-align: right">
                                        รายได้ปัจจุบัน / รับไปทั้งหมด <br />
                                        <span
                                          style="
                                            font-size: 25px;
                                            color: #fddc8c;
                                          "
                                          >{{ sumAff }} /
                                          {{ total_receive }}</span
                                        >
                                        <br />
                                        <div style="position: relative">
                                          ปุ่มถอนรายได้ form>....... 
                                          <br />
                                          <div>
                                            <button
                                              class="btn-grad"
                                              type="submit"
                                              @click="onSubmitReceive"
                                              id="SubmitReceive"
                                            >
                                              <i
                                                class="fas fa-hand-holding-usd"
                                              ></i>
                                              รับรายได้
                                            </button>
                                          </div>
                                          </from>................ 
                                        </div>
                                      </td>-->
                  </tr>
                </tbody>
              </table>
              <div class="pcfriendback">
                <div class="containlinkcopy">
                  <!-- <table style="width: 100%">
                  <tbody>
                    <tr>
                      <td width="70%" style="text-align: center">
                        <input
                          class="friendlink"
                          id="friend"
                          type="text"
                          name="link"
                          readonly=""
                          :value="ref"
                        />
                      </td>
                      <td width="15%" style="text-align: center">
                        <button
                          @click="onclickCopy"
                          class="loginbtn"
                          style="font-size: 10px"
                        >
                          คัดลอกลิงค์
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table> -->
                  <div class="row">
                    <div class="col-12 col-md-8">
                      <input
                        class="friendlink"
                        id="friend"
                        type="text"
                        name="link"
                        readonly=""
                        :value="ref"
                        style="margin-top: 20px"
                      />
                    </div>
                    <div class="col-12 col-md-4">
                      <button
                        @click="onclickCopy"
                        class="loginbtn"
                        style="font-size: 15px"
                      >
                      <i class="fal fa-copy"></i> คัดลอกลิงค์
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="moneycontainaf">
            <div class="pcfriendback">
              <div class="containlinkcopy">
                <table style="width: 100%">
                  <tr>
                    <td width="85%" style="text-align: center" colspan="2">
                      <div class="box1">
                        สามารถรับเครดิตผู้แนะนำจากยอดเสียของเพื่อน
                        โดยจะคำนวณจากวันที่รับค่าแนะนำล่าสุดจนถึงยอดค่าแนะนำของวันนี้
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td width="85%" style="text-align: center" colspan="2">
                      <br />
                      <div class="">
                        คำนวนยอดจากวันที่
                        <span style="color: green">{{ date_start }}</span>
                        ถึงวันที่
                        <span style="color: green">{{ date_end }}</span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td width="85%" style="text-align: center" colspan="2">
                      <div class="">
                        <hr size="4" color="ffffff" width="100%" />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td width="85%" colspan="2">
                      <div class="">
                        <p style="text-align: center">วิธีคำนวน</p>
                        ค่าแนะนำเพื่อนแต่ละคน 5% ของ ยอดได้เสีย(รายวัน)
                        สล็อตและคาสิโน โดยคิดจาก ((ยอดฝาก - ถอน -
                        ยอดคงเหลือเครดิต) x ค่าแนะนำ%)<br />
                        <span style="text-align: left"
                          >*ยอดฝากต้องมากกว่ายอดถอน</span
                        ><br />
                        <span style="text-align: left"
                          >**ยอดที่นำมาคำนวนคือยอดฝากและถอนของเพื่อนที่มีการทำรายการหลังจากวันที่รับค่าแนะนำล่าสุด</span
                        ><br />
                        <span style="text-align: left"
                          >***รับค่าแนะนำได้วันละ 1 ครั้ง เท่านั้น รีเซตสิทธิ์
                          เวลา 23.59 น.</span
                        >
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td width="85%" style="text-align: center" colspan="2">
                      <div class="">
                        <hr size="4" color="ffffff" width="100%" />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td width="ึ0%" style="text-align: left">
                      <div class="">สรุปค่าแนะนำที่ได้รับ</div>
                    </td>
                    <td width="30%" style="text-align: right">
                      <div class="">
                        <span style="color: green; font-size: 16px">{{
                          sumAff
                        }}</span
                        >&nbsp;&nbsp;บาท
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td width="85%" style="text-align: center" colspan="2">
                      <div class="">
                        <button
                          class="loginbtn"
                          type="submit"
                          @click="debounceSubmitReceive"
                          :disabled="isActionInProgress"
                          id="SubmitReceive"
                        >
                        <i class="fal fa-money-bill"></i> รับรายได้
                        </button>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <br />
          <div class="moneycontainaf">
            <div class="friendcontent">
              <div
                style="
                  margin-top: -50px;
                  position: relative;
                  text-align: center;
                  z-index: -1;
                  position: relative;
                "
              >
                <span class="detailaf">รายชื่อเพื่อน {{ Count }} คน </span>
              </div>
              <div class="divoffriends">
                <div>
                  <table style="width: 100%">
                    <tr>
                      <th
                        style="
                          position: relative;
                          text-align: center;
                          width: 40%;
                          font-size: 13px;
                        "
                      >
                        <span> บัญชีเกม </span>
                      </th>
                      <th
                        style="
                          position: relative;
                          text-align: center;
                          width: 40%;
                          font-size: 13px;
                        "
                      >
                        <span> รายได้ </span>
                      </th>
                      <th
                        style="
                          position: relative;
                          text-align: center;
                          width: 20%;
                          font-size: 13px;
                        "
                      >
                        <span> ข้อมูล </span>
                      </th>
                    </tr>

                    <tr v-for="(aff, index) in affData" :key="index">
                      <td
                        style="
                          position: relative;
                          text-align: center;
                          width: 33%;
                          border-right: 1px solid;
                        "
                      >
                        <span>
                          {{ aff.phone }}
                        </span>
                      </td>
                      <td
                        style="
                          position: relative;
                          text-align: center;
                          width: 33%;
                          border-right: 1px solid;
                        "
                      >
                        <span style="color: gold" v-if="aff.aff != '0'">{{
                          aff.aff
                        }}</span
                        ><span style="color: gold" v-else>{{ aff.aff }}</span>
                      </td>
                      <td
                        style="
                          position: relative;
                          text-align: center;
                          width: 33%;
                        "
                      >
                        <vue-modal-2
                          v-bind:name="aff.phone"
                          @on-close="close(aff.phone)"
                          noFooter
                          :headerOptions="{
                            title: 'รายการฝาก - ถอนที่นำมาคิด',
                          }"
                        >
                          <table style="text-align: center;width: 100%">
                            <tr>
                              <td>
                                วันที่ {{ aff.start_at }} ถึง
                                {{ aff.end_at }}<br />
                                บัญชีเกม
                                {{ aff.phone }}
                              </td>
                            </tr>
                          </table>
                          <table style="width: 100%">
                            <tr>
                              <td style="width: 50%">
                                <div class="scroll-friend">
                                  <table
                                    style="width: 100%"
                                    class="text-center"
                                  >
                                    <tr  style="background-color: #BDBDBD; border: 1px solid black;">
                                      <th
                                        style="
                                          position: relative;
                                          text-align: center;
                                          width: 50%;
                                        "
                                        colspan="2"
                                      >
                                        <span> ฝาก </span>
                                      </th>
                                    </tr>
                                    <tr
                                      v-for="(dp, index3) in aff.data_deposit"
                                      :key="index3"
                                    >
                                      <td
                                        style="
                                          position: relative;
                                          text-align: center;
                                          width: 50%;
                                          font-size: 10px;
                                        "
                                      >
                                        <span>{{ dp.date }}</span>
                                      </td>
                                      <td
                                        style="
                                          position: relative;
                                          text-align: center;
                                          width: 50%;
                                          font-size: 10px;
                                          border-right: 1px solid;
                                        "
                                      >
                                        <span>{{ dp.amount }}</span>
                                      </td>
                                    </tr>
                                  </table>
                                </div>
                              </td>
                              <td style="width: 100%">
                                <div class="scroll-friend">
                                  <table style="width: 100%">
                                    <tr style="background-color: #BDBDBD; border: 1px solid black;">
                                      <th
                                        style="
                                          position: relative;
                                          text-align: center;
                                          width: 50%;
                                        "
                                        colspan="2"
                                      >
                                        <span> ถอน</span>
                                      </th>
                                    </tr>
                                    <tr
                                      v-for="(wd, index2) in aff.data_withdraw"
                                      :key="index2"
                                    >
                                      <td
                                        style="
                                          position: relative;
                                          text-align: center;
                                          width: 50%;
                                          font-size: 10px;
                                        "
                                      >
                                        <span>{{ wd.date }}</span>
                                      </td>
                                      <td
                                        style="
                                          position: relative;
                                          text-align: center;
                                          width: 50%;
                                          font-size: 10px;
                                        "
                                      >
                                        <span>{{ wd.credit }}</span>
                                      </td>
                                    </tr>
                                  </table>
                                </div>
                              </td>
                            </tr>
                          </table>
                          <table style="width: 100%">
                            <tr>
                              <td
                                style="
                                  position: relative;
                                  text-align: left;
                                  width: 50%;
                                "
                              >
                                สรุปยอดเสียเพื่อน
                              </td>
                              <td
                                style="
                                  position: relative;
                                  text-align: right;
                                  width: 40%;
                                "
                              >
                                {{ aff.lose }} บาท
                              </td>
                              <td
                                style="
                                  position: relative;
                                  text-align: left;
                                  width: 10%;
                                "
                              ></td>
                            </tr>
                            <tr>
                              <td
                                style="
                                  position: relative;
                                  text-align: left;
                                  width: 50%;
                                "
                              ></td>
                              <td
                                style="
                                  position: relative;
                                  text-align: right;
                                  width: 40%;
                                "
                              ></td>
                              <!-- <td
                                                  style="
                                                    position: relative;
                                                    text-align: left;
                                                    width: 10%;
                                                  "
                                                >
                                                  -
                                                </td> -->
                            </tr>
                            <tr>
                              <td
                                style="
                                  position: relative;
                                  text-align: left;
                                  width: 50%;
                                "
                              >
                                ยอดคงเหลือเครดิต
                              </td>
                              <td
                                style="
                                  position: relative;
                                  text-align: right;
                                  width: 40%;
                                "
                              >
                                {{ aff.balance }} บาท
                              </td>
                              <td
                                style="
                                  position: relative;
                                  text-align: left;
                                  width: 10%;
                                "
                              ></td>
                            </tr>
                            <tr>
                              <td
                                style="
                                  position: relative;
                                  text-align: left;
                                  width: 50%;
                                "
                              ></td>
                              <td
                                style="
                                  position: relative;
                                  text-align: right;
                                  width: 40%;
                                "
                              ></td>
                              <!-- <td
                                                  style="
                                                    position: relative;
                                                    text-align: left;
                                                    width: 10%;
                                                  "
                                                >
                                                  x
                                                </td> -->
                            </tr>
                            <tr>
                              <td
                                style="
                                  position: relative;
                                  text-align: left;
                                  width: 50%;
                                "
                              >
                                เปอร์เซนค่าแนะนำ
                              </td>
                              <td
                                style="
                                  position: relative;
                                  text-align: right;
                                  width: 40%;
                                "
                              >
                                5 %
                              </td>
                              <td
                                style="
                                  position: relative;
                                  text-align: left;
                                  width: 10%;
                                "
                              ></td>
                            </tr>
                            <tr>
                              <td
                                style="
                                  position: relative;
                                  text-align: left;
                                  width: 50%;
                                "
                              ></td>
                              <td
                                style="
                                  position: relative;
                                  text-align: right;
                                  width: 40%;
                                "
                              ></td>
                              <td
                                style="
                                  position: relative;
                                  text-align: left;
                                  width: 10%;
                                "
                              ></td>
                            </tr>
                            <!-- <tr>
                                                <td
                                                  style="
                                                    position: relative;
                                                    text-align: left;
                                                    width: 60%;
                                                  "
                                                ></td>
                                                <td
                                                  style="
                                                    position: relative;
                                                    text-align: right;
                                                    width: 30%;
                                                  "
                                                ></td>
                                                <td
                                                  style="
                                                    position: relative;
                                                    text-align: left;
                                                    width: 10%;
                                                  "
                                                >
                                                  &nbsp;
                                                </td>
                                              </tr> -->
                            <tr>
                              <td
                                style="
                                  position: relative;
                                  text-align: left;
                                  width: 60%;
                                "
                              >
                                สรุปค่าแนะนำที่ได้จากบัญชีนี้
                              </td>
                              <td
                                style="
                                  position: relative;
                                  text-align: right;
                                  width: 30%;
                                "
                              >
                                {{ aff.aff }} บาท
                              </td>
                              <td
                                style="
                                  position: relative;
                                  text-align: left;
                                  width: 10%;
                                "
                              ></td>
                            </tr>
                          </table>
                        </vue-modal-2>
                        <button
                          type="submit"
                          class="btn btn-aff m-1"
                          @click="open(aff.phone)"
                        >
                          <i class="fas fa-users" style="color: #ffce42"></i>
                          <!-- <font-awesome-icon icon="fa-light fa-memo-circle-info" /> -->
                          <!-- <i class="fa-solid fa-phone"></i> -->
                        </button>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="overlaymenu"></div>
  </div>
</template>

<script>
import { HTTP } from "@/services/http-common";
import { mapGetters } from "vuex";
import QrcodeVue from "qrcode.vue";
import Modal from "@burhanahmeed/vue-modal-2";
import Vue from "vue";
Vue.use(Modal);
export default {
  name: "friendmodal-component",
  data() {
    return {
      showModal: false,
      sumAff: "",
      value: "",
      affData: [],
      total_receive: "",
      Count: "",
      size: 120,
      ref: "",
      deposit: [],
      withdraw: [],
      date_start: "",
      date_end: "",
      isActionInProgress: false,
      debounceTimeout: null,
    };
  },
  components: {
    QrcodeVue,
  },

  methods: {
    debounceSubmitReceive() {
    clearTimeout(this.debounceTimeout);
    this.debounceTimeout = setTimeout(() => {
      this.onSubmitReceive();
    }, 1500); // Adjust the delay as needed
  },
    async onSpin() {
      await this.onSubmitReceive();
      document.getElementById("SubmitReceive").click();
    },
    open(phone) {
      this.$vm2.open(phone);
    },
    close(phone) {
      this.$vm2.close(phone);
    },
    show() {
      // let hostname = location.hostname;
      this.ref = `${this.WebSetting.url_affiliate}/gameboard/register?ref=${this.Auth.phone}`;
      this.affData = [];
      this.sumAff = "";
      this.fetchAffData();
    },
    hide() {
      this.showModal = false;
      this.$emit("OpenMenuModalProp", true);
    },
    onSubmitReceive() {
      if (!this.isActionInProgress) {
      if (this.sumAff != 0) {
        this.isActionInProgress = true;
        this.isLoading = true;
        document.getElementById("SubmitReceive").disabled = true;
        HTTP.get(`member/aff?receive`)
          .then((resp) => {
            document.getElementById("SubmitReceive").disabled = false;
            if (resp.data.status != undefined && !resp.data.status) {
              this.hide();
              this.$toast.error(
                resp.data.msg != undefined
                  ? resp.data.msg
                  : "ไม่สามารถทำรายการได้ กรุณาลองใหม่"
              );
            } else {
              this.hide();
              this.fetchUserProfile();
              this.$toast.success(
                resp.data.msg != undefined ? resp.data.msg : "สำเร็จ"
              );
            }
          })
          .catch((err) => {
            this.$toast.error(
              err.data.msg != undefined
                ? err.data.msg
                : "ไม่สามารถทำรายการได้ กรุณาลองใหม่"
            );
          })
          .finally(() => {
          this.isLoading = false;
          this.isActionInProgress = false;
        });
        // .then(() => {
        //   this.isLoading = false;
        // });
      } else {
        this.$toast.error("ไม่มีรายได้");
      }
    }
    },
    fetchAffData() {
      let homeCont = this.$refs.homeCont;
      let loader = this.$loading.show({
        container: homeCont,
        loader: "Dots",
        color: "red",
        opacity: 0.5,
        backgroundColor: "#000000",
      });
      HTTP.get(`member/aff`)
        .then((resp) => {
          if (resp.data.status != undefined && !resp.data.status) {
            this.hide();
            this.$toast.error(
              resp.data.msg != undefined
                ? resp.data.msg
                : "ไม่สามารถโหลดได้ กรุณาลองใหม่"
            );
          } else {
            this.showModal = true;
            this.sumAff = resp.data.sum_aff;
            this.affData = resp.data.data;
            this.total_receive = resp.data.total_receive;
            this.Count = this.affData.length;
            this.deposit = resp.data.data.data_deposit;
            this.withdraw = resp.data.data_withdraw;
            this.date_start = resp.data.start_at;
            this.date_end = resp.data.end_at;
          }
        })
        .catch((err) => {
          this.hide();
          this.$toast.error(
            err.data.msg != undefined
              ? err.data.msg
              : "ไม่สามารถโหลดได้ กรุณาลองใหม่"
          );
        })
        .then(() => {
          loader.hide();
        });
    },
    fetchUserProfile() {
      HTTP.get(`member/profile`)
        .then((resp) => {
          if (resp.data.status != undefined && !resp.data.status) {
            this.$toast.error(
              resp.data.msg != undefined
                ? resp.data.msg
                : "ไม่สามารถโหลดข้อมูลโปรไฟล์ได้ กรุณาลองใหม่"
            );
          } else {
            this.$store.dispatch("saveProfile", resp.data.data);
          }
        })
        .catch((err) => {
          this.$toast.error(
            err.data.msg != undefined
              ? err.data.msg
              : "ไม่สามารถโหลดข้อมูลโปรไฟล์ได้ กรุณาลองใหม่"
          );
        });
    },
    copyToClipboard(textToCopy) {
      //et textToCopy = document.getElementById("rgb").textContent;

      console.log(textToCopy);
      // text area method
      let textArea = document.createElement("textarea");
      textArea.value = textToCopy;
      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      textArea.style.top = "-999999px";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      return new Promise((res, rej) => {
        document.execCommand("copy") ? res() : rej();
        this.$toast.success("คัดลอกสำเร็จ");
        textArea.remove();
      });
    },
    onclickCopy() {
      this.copyToClipboard(this.ref);
    },
  },
  computed: {
    ...mapGetters(["Auth"]),
    ...mapGetters(["WebSetting"]),
    createBackgroundString() {
      return `linear-gradient(140deg, ${this.WebSetting.color1}, #000000 95%), linear-gradient(180deg, #a78059 -30%, #f2d7a9 22%, #715236 72%, #f1bb73 112%)`;
    },
  },
};
</script>

<style scoped>
.-icon {
  color: white;
}
.moneycontainaf {
  width: 100%;
  background: #000000c2;
  border-radius: 20px;
  margin-top: 8px;
  text-align: left;
  color: #fff;
  font-size: 14px;
  padding: 30px 40px;
  border: 1px solid #ffe18c;
}
.moneycontainaf1 {
  width: 100%;
  background: #000000c2;
  border-radius: 20px;
  margin-top: 8px;
  text-align: left;
  color: #fff;
  font-size: 14px;
  padding: 0px 30px 30px;
  border: 1px solid #ffe18c;
}
.box1 {
  background-color: rgb(135 135 135 / 50%);
  border-radius: 10px;
  color: rgb(255, 255, 255);
}
.qrcodebg {
  border-radius: 25px;
  background-color: rgba(255, 255, 255);
  width: 140px;
  height: 140px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.detailaf {
  background: linear-gradient(to right, #8e7050 0%, #89734c 100%);
  padding: 3px 5px;
  border-radius: 5px;
  font-size: 14px;
  font-weight: bold;
}
</style>
